// @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'DueEvent'. Did you mean to use 'import DueEvent from "src/api-parsers/events"' instead?
import type {DueEvent} from 'src/api-parsers/events';
import type {DueEventsAction} from 'src/action-creators/due-events';

import {RECEIVE} from 'src/action-creators/due-events';


export type DueEventsState = {
  [dueEventId: string]: DueEvent;
};

export default (
  state: DueEventsState | null | undefined = Object.freeze({}),
  action: DueEventsAction,
): DueEventsState => {
  switch (action.type) {
    case RECEIVE: {
      return action.payload.reduce(
        (dueEvents, dueEvent) => {
          dueEvents[dueEvent.id] = dueEvent;
          return dueEvents;
        },
        {...state},
      );
    }
  }
  // @ts-expect-error - TS2322 - Type 'DueEventsState | null' is not assignable to type 'DueEventsState'.
  return state;
};
